import React, { Component } from 'react';
import { Toast, ActivityIndicator } from 'antd-mobile';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import check from './images/check.png';
import goImg from './images/go.png';

import styles from './styles.module.less';

import {
  getTaskCompletion,
  getChannelApplyForm,
  getTaskCompletionUserId,
  getChannelApplyFormByUserId,
  getSignInfo,
} from '../../service/chat-service';

import tools from '../../utils/tools';

const propTypes = {
  history: PropTypes.shape({ push: PropTypes.func }).isRequired,
};

class ChannelLevel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      form: {},
      tasks: [],
      pageSize: 10000,
      pageNum: 1,
      animating: false,
      // maxTimes: '',
      channelApplyForm: [],
      categoryType: '',
      channelUserId: undefined,
      channelUserIdFlag: false,
    };
    document.title = '渠道等级';
  }

  async componentDidMount() {
    const token = tools.getQueryString('token');
    const userId = tools.getQueryString('userId');
    if (token && userId) {
      localStorage.setItem('token', token);
      localStorage.setItem('userId', userId);
    }
    this.handleTitle('渠道升级');
    this.judgeAndroidOrIos();
    this.getUrlSearch();
  }

  // 获取url参数
  getUrlSearch = () => {
    const channelUserId = tools.getQueryString('channelUserId');
    if (channelUserId !== 'undefined') {
      this.setState({ channelUserId, channelUserIdFlag: true }, () => {
        this.getLevelCompletion();
      });
    } else {
      this.getLevelCompletion();
    }
  }

  // 判断安卓、ios环境

  judgeAndroidOrIos = () => {
    let rootPhoneEnvironment = null;
    const u = navigator.userAgent;
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isAndroid) rootPhoneEnvironment = document;
    if (isiOS) rootPhoneEnvironment = window;
    this.handlePageBack(rootPhoneEnvironment);
  }

  // h5与App之间通信判断 返回

  handlePageBack = (rootPhoneEnvironment) => {
    const that = this;
    if (window.ReactNativeWebView) {
      rootPhoneEnvironment.addEventListener('message', (e) => {
        const data = JSON.parse(e.data);
        if (data.type === 'back') {
          if (window.location.pathname.indexOf('channelLevel') > -1) {
            window.ReactNativeWebView.postMessage(
              JSON.stringify({
                type: 'back',
              }),
            );
          } else {
            that.props.history.go(-1);
          }
        }
      });
    }
  }

  // 查询查询申请表、考试的问题是否为空

  getApplyForm = async (item) => {
    const { history } = this.props;
    const {
      channelUserId, channelUserIdFlag, pageSize, pageNum,
    } = this.state;

    const server = channelUserIdFlag ? getChannelApplyFormByUserId : getChannelApplyForm;
    let category = 1;
    if (item.type === 4) {
      category = 2;
    }
    this.setState({ categoryType: category });
    try {
      if (item.type === 4 || item.type === 2) {
        const { data, code } = await server(pageSize, pageNum, category, channelUserId);
        if (code === 10000) {
          history.push(
            `/channelList?type=${category || ''}&settingId=${data.settingId || ''}&channelType=${
              item.status || ''
            }&channelUserId=${channelUserId || ''}`,
          );
        } else {
          Toast.show('暂未开通');
        }
        // this.setState({ channelApplyForm: data.pageList || [], settingId: data.settingId })
      }
    } catch (e) {
      Toast.show(e);
    }
  }

  // 查看任务完成状态
  getLevelCompletion = async () => {
    const { channelUserIdFlag, channelUserId } = this.state;

    try {
      const server = channelUserIdFlag ? getTaskCompletionUserId : getTaskCompletion;

      this.setState({ animating: true });
      const { data } = await server(channelUserId);
      this.setState({ form: data, tasks: data.tasks, animating: false });
    } catch (e) {
      this.setState({ animating: false });
    }
  }

  // 设置title
  handleTitle = (title) => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: 'title',
          payload: title,
        }),
      );
    }
  }

  // 单纯h5 路由匹配
  handleH5Routes = (task) => {
    switch (task.type) {
      case 1:
        return 'completeMaterial';
      case 2:
        return 'channelList';
      case 3:
        return 'productDetail';
      case 4:
        return 'channelList';
      case 5:
        return 'protocol';
      case 6:
        return 'verified';
      default:
        return '';
    }
  }

  // h5环境
  handleH5GoPage = async (item) => {
    const { history } = this.props;
    const {
      channelUserId, channelUserIdFlag, channelApplyForm, categoryType, settingId,
    } = this.state;
    if (item.type === 2 || item.type === 4) {
      await this.getApplyForm(item);
      if (channelApplyForm.length > 0) {
        history.push(
          `/${this.handleH5Routes(item)}?type=${categoryType}&settingId=${
            settingId
          }&channelType=${item.status}&channelUserId=${channelUserId || ''}`,
        );
      } else {
        Toast.show('暂未开通！');
      }
    } else {
      if (item.status === 1 && !channelUserIdFlag) return;
      if (item.type === 3) {
        history.push('/studyFiles');
        return;
      }

      history.push(`/${this.handleH5Routes(item)}?channelUserId=${channelUserId || ''}`);
    }
  }

  // App环境
  handleAppGoPage = async (item) => {
    const { history } = this.props;
    const { channelUserId, channelUserIdFlag } = this.state;

    const data = [
      {
        title: '完善个人资料 ',
        navigate: 'UserData',
        productId: '',
        type: 1,
        bool: '',
        channelUserId,
      },
      {
        title: '签署渠道合约',
        navigate: 'ChannelProtocol',
        productId: '',
        type: 5,
        bool: '',
        channelUserId,
      },
      {
        title: '实名认证',
        navigate: 'Verified',
        productId: '',
        type: 6,
        bool: '',
        channelUserId,
      },
    ];
    const productType = data.filter((items) => items.type === item.type);

    // 如果申请表、在线考试,培训则跳转h5
    if (item.type === 2 || item.type === 4) {
      await this.getApplyForm(item);

      let title = '填写申请表';
      if (item.type === 4) {
        title = '在线通过考试';
      }

      this.handleTitle(title);
    } else if (item.type === 3 && item.status !== 1) {
      history.push('/studyFiles');
    } else {
      // 如果是完成状态且是渠道则不能跳转
      if (item.status === 1 && !channelUserIdFlag) return;

      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: 'title',
          payload: productType[0].title,
        }),
      );
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: 'navigate',
          payload: {
            route: productType[0].navigate,
            params: {
              productId: productType[0].productId || '',
              study: productType[0].bool,
              channelUserId: productType[0].channelUserId,
            },
          },
        }),
      );
    }
  }

  handleGoPage = async (item) => {
    const { channelUserIdFlag } = this.state;

    // 员工审核进入该页面任务没做的不允许跳转
    if (item.status === 2 && channelUserIdFlag) return;

    // 如果是签署合约，接口未返回签署信息则不跳转
    if (item.type === 5) {
      try {
        const data = await getSignInfo();
        if (!data) {
          Toast.show('暂未开通');
          return;
        }
      } catch (e) {
        return;
      }
    }

    // 如果只是h5环境
    if (!window.ReactNativeWebView) {
      this.handleAppGoPage(item);
    } else {
      this.handleAppGoPage(item);
    }
  }

  renderTaskStatus = () => {
    const { channelUserIdFlag, tasks, form } = this.state;
    if (!tasks.length) return (<div />);
    return tasks.map((item) => {
      let itemColor;
      let itemStatus;
      let itemSrc;
      if (item.status === 4) {
        itemColor = '#FF0000';
      } else {
        itemColor = item.status === 1 ? '#79cb2a' : '#848484';
      }
      if (item.status === 1) {
        itemStatus = '完成';
      } else if (item.status === 2 && !channelUserIdFlag) {
        itemStatus = '前往';
      } else if (item.status === 3) {
        itemStatus = '等待审阅';
      } else if (item.status === 4) {
        itemStatus = '未通过';
      } else if (item.status === 2 && channelUserIdFlag) {
        itemStatus = '未完成';
      } else {
        itemStatus = '';
      }
      if (item.status === 1) {
        itemSrc = check;
      } else if (item.status === 2) {
        itemSrc = goImg;
      } else {
        itemSrc = '';
      }
      return (
        <div className={styles.channelItem} key={item.type}>
          <div>{item.typeName}</div>
          <div style={{ display: form.nextLevelType !== 1 ? 'none' : 'block' }}>
            <div onClick={this.handleGoPage.bind(this, item)} style={{ display: 'flex', alignItems: 'center' }} role="button" tabIndex={0}>
              <span
                style={{
                  color: itemColor,
                  fontSize: '14px',
                }}
              >
                {itemStatus}
              </span>
              <img
                style={{
                  float: 'right',
                  display:
                    item.status === 3 || (item.status === 2 && channelUserIdFlag) || item.status === 4 ? 'none' : '',
                }}
                src={itemSrc}
                alt=""
              />
            </div>
          </div>
        </div>
      );
    });
  }

  render() {
    const { channelUserIdFlag, form, animating } = this.state;

    return (
      <div className={styles.box}>
        <div className={styles.topBanner}>
          <div className={styles.bannerText1}>
            {channelUserIdFlag ? form.realName : '我'}
            在
            {' '}
            {form.companyName}
            {' '}
            渠道等级
          </div>
          <div className={styles.bannerText2}>{form.taskLevel}</div>
        </div>
        <div className={styles.line}>
          完成下面的任务即可升到
          {form.nextLevelName}
          级渠道
        </div>
        {this.renderTaskStatus()}
        <ActivityIndicator toast text="正在加载" animating={animating} />
      </div>
    );
  }
}

ChannelLevel.propTypes = propTypes;

export default withRouter(ChannelLevel);
